<template>
  <div v-if="active" class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-50"></div>
  <div v-if="active" class="fixed inset-0 flex justify-center items-center z-50 blur-none my-44" @click="closePopup">
    <div class="bg-[#fff] w-fit py-4 overflow-hidden flex flex-col border-2 border-b-gray-300 absolute"
      @click="handleClickPropagation">
      <div>
        <LbrxKeyboard :textInput="textInput"  :isNumeric="isNumeric"  @addLetter="addLetter" @removeLetter="removeLetter"
          @closePopup="closePopup" />
      </div>
    </div>
  </div>
</template>

<script>
import LbrxKeyboard from "@/components/LbrxKeyboard.vue"
export default {
  name: "LbrxKeyboardPopup",
  components: {
    LbrxKeyboard
  },
  data() {
    return {
      activeKey: '0',
      textInput: ""
    };
  },
  props: {
    active: {
      required: true,
      value: Boolean
    },
    isNumeric: {
      required: false,
      value: Boolean,
      default: false
    }
  },
  methods: {
    closePopup() {
      this.$emit("closePopupKeyboard", this.textInput)
      this.textInput = "";
    },
    handleClickPropagation() {
      event.stopPropagation();
    },
    confirmCoupon() {
      this.$emit("confirmCoupon", this.couponCode)
      this.couponCode = "";
    },
    addAmount(item) {
      if (item === -1) {
        this.amount = "";
      } else if (item === -2) {
        this.amount = this.pinCode.substring(0, this.pinCode.length - 1);
      } else {
        this.amount += item;
      }
    },
    selectType(type) {
      this.selectedType = type;
    },
    addLetter(letter) {
      this.textInput += letter;
    },
    removeLetter() {
      this.textInput = this.textInput.slice(0, -1);
    },
    addSelectedInput(text) {
      this.textInput = text;
    }
  }
};
</script>

<style scoped>
input[type=checkbox] {
  transform: scale(1.5);
}
</style>